confirm_handler = {

    properties: {
    },

    onLoad: function(){
        var self = this;

    },

    events: function() {
        var self = this;

        $('.add-feedback').click(function(event) {
          feedback_handler.turnOn();
          return false;
        });
        
    }
}